export default {
  somedata: 'This is somedata from the mock api'
}


// WEBPACK FOOTER //
// ./src/api/mock/data/app.js